
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"3","d":"M0 0h17v1H0V0zm0 12h17v1H0v-1zM1 1v11H0V1h1zm16 0v11h-1V1h1zm-2 1v9h-3V2h3zm-5 0v9H9V2h1zm2 1h-2V2h2v1zm0 8h-2v-1h2v1z","fill":"#818181","fill-rule":"evenodd"}})])
          )
        }
      }
    